<template>
  <article class="page-catalogues-list-block">
    <!-- Image -->
    <div class="page-catalogues-list-block__image">
      <a
        :href="catalogue.catalogueFileUrl"
        :data-hoverable="catalogue?.cta || $t('cursor.download')"
      >
        <WidgetPicture
          :image="{
            custom: props.catalogue.catalogueCover?.[0],
          }"
          :lazyLoad="true"
          :alt="props.catalogue.catalogueCover?.[0]?.title"
        />
      </a>
    </div>
    <div class="page-catalogues-list-block__content m-top-16px">
      <!-- Header -->
      <header class="m-bottom-24px">
        <p class="text-uppercase text">
          {{ catalogue?.preTitle || $t('bucket.preTitleCatalogue') }}
        </p>
        <a
          :href="catalogue.catalogueFileUrl"
          :data-hoverable="$t('cursor.download')"
          target="_blank"
          rel="noreferrer"
        >
          <h2 class="title-s m-top-8px">
            {{ props.catalogue.catalogueTitle }}
          </h2>
        </a>

        <!--Link -->
        <WidgetLinkMainUnderline
          class="m-top-16px"
          :link="{
            title: catalogue?.cta || $t('cta.download'),
            href: catalogue.catalogueFileUrl,
          }"
        />
      </header>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PagesCataloguesListBlock',
}
</script>

<script setup>
const props = defineProps({
  catalogue: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
